import PropTypes from 'prop-types';

import { TOP_LEVEL_CATEGORY_ID } from 'app/constants/AdminBrowseConstants';
import { LOCALE_CODE } from 'app/constants/language';

export const categoryShape = PropTypes.exact({
  categoryId: PropTypes.string.isRequired,
  isEnabled: PropTypes.bool.isRequired,
  searchUrl: PropTypes.string.isRequired,
  slug: PropTypes.string.isRequired,
  subCategoryIds: PropTypes.arrayOf(PropTypes.string).isRequired,
  title: PropTypes.string.isRequired
});

export const categoryConfigShape = PropTypes.exact({
  categoryConfigId: PropTypes.string, // new categories have a null id until saved
  categoryConfigSchemaVersion: PropTypes.oneOf(['1.0.0']).isRequired,
  categoryById: PropTypes.objectOf(categoryShape).isRequired,
  localeCode: PropTypes.oneOf(Object.values(LOCALE_CODE)).isRequired,
  subdomain: PropTypes.string.isRequired,
  topLevelCategoryId: PropTypes.oneOf(Object.values(TOP_LEVEL_CATEGORY_ID)).isRequired,
  updatedAt: PropTypes.number.isRequired,
  updatedBy: PropTypes.string.isRequired
});

export const categoryConfigSummaryShape = PropTypes.exact({
  categoryConfigId: PropTypes.string.isRequired,
  createdBy: PropTypes.string.isRequired,
  localeCode: PropTypes.oneOf(Object.values(LOCALE_CODE)).isRequired,
  name: PropTypes.string.isRequired,
  topLevelCategoryId: PropTypes.oneOf(Object.values(TOP_LEVEL_CATEGORY_ID)).isRequired,
  updatedAt: PropTypes.number.isRequired,
  updatedBy: PropTypes.string.isRequired
});
